var interest_editor = (function( $ ) {

	var _init = function() {
		$( 'a.toggle-editor' ).on( 'click', _toggle_editor );
	};

	var _toggle_editor = function( e ) {
		$( this ).closest( '.interest' ).find( '.interest-editor' ).toggle();

		e.preventDefault();
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = interest_editor;